import React from "react";
import { copy } from "shared/assets";

import { Modal, Button, Message, ButtonContainer, MessageProps } from "shared/components";
import { Spacer } from "shared/layout";
import { ContentWidth } from "shared/styles/constants";
import { ITheme } from "shared/types";

interface MessageModalProps extends MessageProps {
  title?: string;
  icon?: React.ComponentType<any>;
  buttons?: JSX.Element;
  handleClose?: () => void;
}

export const MessageModal: React.FC<MessageModalProps> = ({
  title,
  icon,
  buttons,
  handleClose,
  ...rest
}) => {
  return (
    <Modal
      handleClose={handleClose}
      title={title}
      icon={icon}
      dataTestId="message_modal"
      width={ContentWidth.narrow}
    >
      <Spacer size="s">
        <Message hideBackground {...rest} />
        <ButtonContainer>
          {buttons || (
            <Button theme={ITheme.secondary} onClick={handleClose}>
              {copy.actions.close}
            </Button>
          )}
        </ButtonContainer>
      </Spacer>
    </Modal>
  );
};
